import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import CompareModal from 'components/Catalog/ProductGrid/CompareModal/CompareModal';
import CompareModalEN from 'components/Catalog/ProductGrid/CompareModal/locales/CompareModal_en_US.js';
import CompareModalFR from 'components/Catalog/ProductGrid/CompareModal/locales/CompareModal_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(CompareModalEN, CompareModalFR);

const withCompareModalLocale = wrapHOC(WrappedComponent => {
    const CompareModalWithLocale = props => (
        <WrappedComponent
            {...props}
            getText={getText}
        />
    );

    return CompareModalWithLocale;
});

export default withCompareModalLocale(CompareModal);
